import { IS_STAGING } from '@constants';
import { Contract } from '@ethersproject/contracts';
import { JsonRpcSigner, JsonRpcProvider } from '@ethersproject/providers';
import ERC20Abi from '../../abi/ERC20.json';
import { NETWORKS } from '../networks';

export function getERC20Contract(
  address: string,
  library?: JsonRpcSigner,
  isWrite = false,
) {
  if (isWrite && !library) {
    throw new Error('Write contract must provide signer');
  }

  if (isWrite) {
    return new Contract(address, ERC20Abi, library);
  }

  // Use BSC RPC endpoints instead of BscscanProvider
  const bscRpcUrl =
    IS_STAGING === 'true' ? NETWORKS[97].rpc[0] : NETWORKS[56].rpc[0];
  const bscProvider = new JsonRpcProvider(bscRpcUrl);
  return new Contract(address, ERC20Abi, bscProvider);
}
